import useEnumValues from 'app/hooks/useEnumValues'

import {
    useAppSelector,
} from 'app/store/hooks'
import {
    selectConfigByFieldName,
} from 'app/store/Configs'

type Props = {
    configName?: string,
    mapCellProps: string,
    value?: string,
    className?: string,
    allowedValuesEnum?: Record<string, string>,
}

const defaultProps = {
    value: '',
    configName: null,
    className: null,
    allowedValuesEnum: undefined,
}

const EnumValue = ({
    className,
    configName,
    mapCellProps,
    value,
    allowedValuesEnum,
}: Props) => {
    const fieldConfig = useAppSelector((state) => {
        return selectConfigByFieldName(state, configName, mapCellProps)
    })

    // TODO-DM: we can rid off redux props passing when RichTable is killed
    const allowedValues = useEnumValues()(allowedValuesEnum || fieldConfig?.allowedValuesEnum)

    if (!(allowedValuesEnum || fieldConfig?.allowedValuesEnum)) {
        // eslint-disable-next-line no-console
        console.error(`No allowed values config found for "${mapCellProps}" field in "${configName}"`)
    }

    return (
        <div className={className}>{allowedValues[value] || value}</div>
    )
}

EnumValue.defaultProps = defaultProps

export default EnumValue
